// String values match the IModuleAccess keys exactly so that
// settings.modules[CompanyModule.X] stays type-safe.
export enum CompanyModule {
  EMPLOYER_BRANDING = 'employerBranding',
  ONBOARDING = 'onboarding',
  PERFORMANCE_MANAGEMENT = 'performanceManagement',
  // Advanced engagement, on suite only: the culture scan. Surveys themselves are on
  // every plan, so this does not gate them.
  ENGAGEMENT = 'engagement',
  // Part of performance management: only on while that is on too
  JOURNALS = 'journals',
}
